import { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Redirect } from 'react-router'
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts'
import SmartBanner from 'react-smartbanner'
import 'react-smartbanner/dist/main.css'

import { MatchModal } from 'modals'
import images from 'static'
import { HOME, NO_NETWORK, ROOMMATE_PROFILE_ROUTE, PROFILE_SHARE, WELCOME } from 'constants/urls'
import { contentActions } from 'redux/actions/ContentActions'
import { roomActions } from 'redux/actions/RoomActions'
import { profileActions } from 'redux/actions/ProfileActions'
import { chatActions } from 'redux/actions/ChatActions'
import routeSelectors from 'redux/selectors/RouteSelectors'
import userSelectors from 'redux/selectors/UserSelectors'
import profileSelectors from 'redux/selectors/ProfileSelectors'
import communitySelectors from 'redux/selectors/CommunitySelectors'

import s from './SignedInLayout.module.scss'


class SignedInLayout extends PureComponent {
  componentDidMount() {
    const {
      isAuthenticated, initializeChat, isRegistrationFlow,
      getMyRoom, getBasicinfo, getProfile, getProfileOverview
    } = this.props

    if (!isRegistrationFlow && isAuthenticated) {
      initializeChat()
    }

    // Only fetch authenticated resources when the user is authenticated
    if (isAuthenticated) {
      getBasicinfo()
      getMyRoom()
      getProfile()
      getProfileOverview()
    }

    // Refresh profile overview when user returns to the tab/window
    // This ensures network pause status is updated without requiring logout
    window.addEventListener('focus', this.handleWindowFocus)
  }

  componentDidUpdate(prevProps) {
    const { logoutChat, initializeChat, isRegistrationFlow } = this.props

    if (prevProps.isRegistrationFlow && !isRegistrationFlow) {
      initializeChat()
    } else if (!prevProps.isRegistrationFlow && isRegistrationFlow) {
      logoutChat()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.handleWindowFocus)
  }

  handleWindowFocus = () => {
    const { isAuthenticated, getProfileOverview } = this.props

    // Refresh profile overview to get latest network pause status
    if (isAuthenticated) {
      getProfileOverview()
    }
  }

  render() {
    const {
      children, isRegistrationFlow, isAuthenticated, networkId, pathname, search,
      isNetworkClosed, isNetworkPaused, isClosedFlow
    } = this.props

    if (!isAuthenticated) {
      // Allow public interstitial route to render without redirecting to HOME
      if (pathname && pathname.startsWith('/profile-share/')) {
        return null;
      }
      // If unauthenticated and on a direct profile URL, send to the public interstitial
      if (pathname && pathname.startsWith(ROOMMATE_PROFILE_ROUTE)) {
        const roommateId = pathname.slice(ROOMMATE_PROFILE_ROUTE.length).split('/')[0];
        if (roommateId) {
          const params = new URLSearchParams(search || '');
          // If the user came from the share page and chose Continue, allow direct profile
          if (params.get('fromShare') === '1') {
            return <Redirect to={`${pathname}${search || ''}`} />;
          }
          const to = `${PROFILE_SHARE.replace(':profileId', roommateId)}${search || ''}`;
          return <Redirect to={to} />;
        }
      }
      return <Redirect to={HOME} />
    }

    if (!networkId) {
      return <Redirect to={NO_NETWORK} />
    }

    // Redirect to WELCOME page when network is closed or paused
    // Allow access only to routes defined in closedPathnames (see constants/arrays.js)
    if ((isNetworkClosed || isNetworkPaused) && !isRegistrationFlow && !isClosedFlow && !pathname.includes(ROOMMATE_PROFILE_ROUTE)) {
      return <Redirect to={WELCOME} />
    }

    return (
      <Fragment>
        <SmartBanner
          title='RoomSync'
          button='Open App'
          position='top'
          daysHidden={1}
          daysReminder={1}
          ignoreIosVersion
          author='U-Match, LLC'
          url={{
            ios: process.env.REACT_APP_BASE_MOBILE_BANNER_LINK,
            android: process.env.REACT_APP_BASE_MOBILE_BANNER_LINK
          }}
        />

        <div className={s.content}>
          <div className={s.content}>
            {children}
            {isRegistrationFlow &&
              <img src={images.registerPlaceholder} alt="" className={s.placeholder} />
            }
          </div>
        </div>
        <MatchModal />
        <ToastsContainer
          lightBackground
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  networkId: userSelectors.networkIdSelector,
  isAuthenticated: userSelectors.isAuthenticatedSelector,
  aboutMeHasAllAnswers: profileSelectors.aboutMeHasAllAnswersSelector,
  isRegistrationFlow: routeSelectors.isRegistrationFlow,
  isClosedFlow: routeSelectors.isClosedFlowSelector,
  isNetworkClosed: communitySelectors.isNetworkClosedSelector,
  isNetworkPaused: profileSelectors.isNetworkPausedSelector,
  pathname: routeSelectors.currentPathnameSelector,
  search: (state) => state.router?.location?.search,
})

const mapDispatchToProps = {
  logoutChat: chatActions.logoutChat,
  initializeChat: chatActions.initializeChat,
  getMyRoom: roomActions.getRoomContent,
  getProfile: profileActions.getProfile,
  getProfileOverview: profileActions.getProfileOverview,
  getBasicinfo: contentActions.getVerifyInfoContent,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignedInLayout)
